import React, { memo } from "react";
import { makeStyles } from "@material-ui/core";
import { View } from "../../../Base";

const useStyles = makeStyles(() => ({
  list: {
    overflowY: "overlay",
    maxHeight: "100%",
    height: "100%",
  },
  "@supports ( -moz-appearance:none )": {
    list: {
      overflowY: "auto",
      scrollbarWidth: "thin",
    },
  },
}));

export const ListWrapper = memo(({ children }) => {
  const styles = useStyles();
  return <View className={styles.list}>{children}</View>;
});
